import React from 'react';
import PropTypes from 'prop-types';
import SharedProgressBar from 'components/ProgressBar';
import { isLive, isStaticRender } from 'helpers/ContentHelper';

const ProgressBar = props => {
  const { video, theme } = props;
  if (!video) return null;
  const { '@type': type, endDate, percentWatched, startDate } = video;
  const videoHasPercentWatched = typeof percentWatched === 'number' && percentWatched >= 0;
  const showLiveProgressBar = isLive(type) && !isStaticRender();
  const shouldRender = videoHasPercentWatched || showLiveProgressBar;
  if (!shouldRender) return null;

  return (
    <SharedProgressBar
      endDate={endDate}
      percentWatched={percentWatched}
      startDate={startDate}
      theme={theme}
    />
  );
};

export default ProgressBar;

ProgressBar.defaultProps = {
  theme: null,
  video: null,
};

ProgressBar.propTypes = {
  theme: PropTypes.shape({}),
  video: PropTypes.shape({}),
};
